function scrollToSection (e) {
  e.preventDefault()
  const target = e.target.getAttribute('href')
  const targetElement = document.querySelector(target)

  if (!targetElement) return
  targetElement.scrollIntoView({ behavior: 'smooth' })
}

export default function initScrollToSection () {
  document.querySelectorAll('[data-section-scroll]').forEach(sectionLink => {
    sectionLink.addEventListener('click', scrollToSection)
  })
}
